import Head from 'next/head';

import { ProductStructure } from '../../../types/Products';

type Props = {
  product: ProductStructure;
};

const ProductLd = ({ product }: Props) => {
  const mapAvailability = (a: string) => {
    switch (a) {
      case 'available':
      case 'enquiry':
        return 'https://schema.org/InStock';
      case 'coming soon':
        return 'https://schema.org/PreOrder';
      case 'sold out':
        return 'https://schema.org/SoldOut';
      case 'unavailable':
        return 'https://schema.org/OutOfStock';
      default:
        return null;
    }
  };

  const addProductLd = () => {
    const offers = product.pricesAndAvailability.pricesAndCurrencies.map(
      (priceAndCurrency: PriceAndCurrency) => ({
        '@type': 'Offer',
        priceCurrency: priceAndCurrency.currency,
        price: priceAndCurrency.price,
        itemCondition: 'https://schema.org/NewCondition',
        availability: mapAvailability(product.availability),
        url: product.url,
      }),
    );

    const productLd = {
      '@context': 'https://schema.org',
      '@type': ['Product', 'VisualArtwork'],
      name: product.name,
      image: product.image,
      primaryImageOfPage: product.image,
      description: product.description,
      artMedium: product.artMedium,
      artist: {
        '@type': 'Person',
        name: product.artistName,
        url: product.artistUrl,
      },
      offers,
    };

    return {
      __html: JSON.stringify(productLd),
    };
  };

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={addProductLd()}
        key="product-jsonld"
        type="application/ld+json"
      />
    </Head>
  );
};

export default ProductLd;
